import { CheckCircle2, MinusCircle, XCircle } from 'lucide-react';

import type { CutoverCheck } from './cutover.types';

const STATUS_NOTE: Record<CutoverCheck['status'], string | null> = {
  passed: null,
  failed: null,
  cannot_run: 'Could not run',
  not_configured: 'Not configured',
};

function StatusIcon({ status }: { status: CutoverCheck['status'] }) {
  if (status === 'passed') {
    return (
      <CheckCircle2
        className="mt-0.5 h-4 w-4 shrink-0 text-green-600"
        aria-label="Passed"
      />
    );
  }
  if (status === 'not_configured') {
    return (
      <MinusCircle
        className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground"
        aria-label="Not configured"
      />
    );
  }
  return (
    <XCircle
      className="mt-0.5 h-4 w-4 shrink-0 text-destructive"
      aria-label={status === 'cannot_run' ? 'Could not run' : 'Failed'}
    />
  );
}

export function CheckList({
  checks,
  emptyText,
}: {
  checks: CutoverCheck[];
  emptyText: string;
}) {
  if (checks.length === 0) {
    return <p className="text-sm text-muted-foreground">{emptyText}</p>;
  }
  return (
    <ul className="space-y-2">
      {checks.map((check) => {
        const note = STATUS_NOTE[check.status];
        return (
          <li key={check.name} className="flex gap-2 text-sm">
            <StatusIcon status={check.status} />
            <div>
              <p className="font-medium">
                {check.name}
                {note && (
                  <span className="font-normal text-muted-foreground">
                    {' '}
                    ({note})
                  </span>
                )}
              </p>
              {check.value !== null && (
                <p>
                  {check.value}
                  {check.limit !== null && (
                    <span className="text-muted-foreground">
                      {' '}
                      · limit: {check.limit}
                    </span>
                  )}
                </p>
              )}
              <p className="text-muted-foreground">{check.detail}</p>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
